import React, { useEffect, useState } from 'react';
import { listDocumentsResult } from '@/modules/documents/services';
import EntityLinkButton from '../../../../shared/components/linked-entities/EntityLinkButton';
import { useLinkedEntityCards } from '../../../../shared/components/linked-entities/LinkedEntityCardHost';

export default function ExpenseDocuments({ expense }) {
  const { openEntityCard } = useLinkedEntityCards();
  const [state, setState] = useState({ id: null, loading: true, documents: [], error: '' });
  useEffect(() => {
    let active = true;
    const id = expense.id;
    if (!id) {
      setState({ id, loading: false, documents: [], error: '' });
      return undefined;
    }
    setState({ id, loading: true, documents: [], error: '' });
    async function load() {
      try {
        const result = await listDocumentsResult({ linkedModule: 'ACCOUNTING', linkedEntityType: 'ACCOUNTING_EXPENSE', linkedEntityId: id });
        if (!active) return;
        setState({ id, loading: false,
          documents: result.ok ? [...new Map((result.data?.documents || []).map(document => [String(document.id), document])).values()] : [],
          error: result.ok ? '' : result.message || 'Documenti non disponibili.',
        });
      } catch (error) {
        if (active) setState({ id, loading: false, documents: [], error: 'Impossibile caricare i documenti della spesa.' });
      }
    }
    load();
    return () => { active = false; };
  }, [expense.id]);

  if (state.id !== expense.id || state.loading) return <span role="status">Caricamento documenti...</span>;
  if (state.error) return <span role="alert" className="wt-inline-error">{state.error}</span>;
  const legacyName = expense.attachmentName || expense.fileName;
  if (!state.documents.length) return <>
    <span>{legacyName || 'Nessun allegato'}</span>
    <span className="expense-detail__hint">{legacyName ? 'Allegato indicato nella spesa' : 'Nessun documento disponibile'}</span>
  </>;
  return <div className="expense-detail__links">{state.documents.map(document =>
    <EntityLinkButton key={document.id} onClick={() => openEntityCard({ entityType: 'document', entityId: document.id })}>
      {document.name || document.fileName || `Documento ${document.id}`}
    </EntityLinkButton>
  )}</div>;
}
